import Request from '../../components/request'
import Vars from '../../vars'

class Auth {
    constructor () {
        let self = this;
        self._init();
    }

    _elems = {
        $_ : $()
    }

    _utils = {
        validation : null
    }

    _bindElements = () => {
        let self = this

        self._elems.$_ = $('#form-auth')
    }

    _bindUI = () => {
        let self = this
        if (!self._elems.$_.length) return;

        self._elems.$_.on('submit', self._bindSubmit)

        self._elems.$_.find('input').keyup(function(){
            self._elems.$_.find('.form-field[data-name]').each(function() {
                $(this).removeClass('error');
                $(this).find('.form-field__message').hide().addClass('hidden');
            });
            $('.content-form__error').text('').hide();
        })
    }

    _bindSubmit = (e) => {
        e.preventDefault()

        let self = this

        loader.increase()
        Request.send({
            path   : '/login',
            method : 'POST',
            data   : self._elems.$_.serialize(),
            done   : (response) => {
                if (!response.error) {
                    window.location.href = '/profile'
                    return
                }

                loader.decrease()
                let error = response.error
                if (error.type == 'validation') {
                    self._elems.$_.find('.form-field[data-name]').each(function() {
                        $(this).removeClass('error');
                        $(this).find('.form-field__message').hide().addClass('hidden');
                    });

                    Object.keys(error.fields).forEach(function(fieldName) {
                        self._elems.$_.find('.form-field[data-name=' + fieldName.replace(/\./g, '\\.')  + '], .form-field__wrapper[data-name=' + fieldName.replace(/\./g, '\\.')  + ']').each(function() {
                            let $field = $(this);
                            $field.addClass('error');

                            if (!$field.find('.form-field__message').length) {
                                $field.append(
                                    $('<div />')
                                        .addClass('form-field__message')
                                )
                            }
                            $field.find('.form-field__message').each(function() {
                                $(this).removeClass('hidden').show().html(error.fields[fieldName].join('<br />'));
                            });
                        });
                    });

                    let firstFieldName = Object.keys(error.fields)[0].replace(/\./g, '\\.');
                    let $first = self._elems.$_.find('.form-field[data-name=' + firstFieldName + ']').find('input, select');
                    $first.focus();
                }
                else if (error.type == 'auth') {
                    $('.content-form__error').text(error.text).show();
                }
            }
        })
    }

    _init = () => {
        let self = this

        self._bindElements()
        self._bindUI()

        document.title = 'Авторизация. ' + Vars.title
    }
}

export default Auth